import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        MatSlideToggleModule,
        MatProgressSpinnerModule
    ],
    exports: [
        MatSlideToggleModule,
        MatProgressSpinnerModule
    ],
    providers: [
    ]
})

export class MaterialModule { }
